import { render, staticRenderFns } from "./topping-form.vue?vue&type=template&id=4781966e&scoped=true&"
import script from "./topping-form.vue?vue&type=script&lang=js&"
export * from "./topping-form.vue?vue&type=script&lang=js&"
import style0 from "./topping-form.vue?vue&type=style&index=0&id=4781966e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781966e",
  null
  
)

export default component.exports